import "./global.css";
import { useEffect, useState } from "react";
import {
  NotificationProvider,
  useNotification,
} from "./context/NotificationContext.jsx";
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  Outlet,
} from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import Headers from "./components/layout/Header.jsx";
import NavbarAside from "./components/layout/navbarAside.jsx";
import Dashboard from "./pages/dashboard/dashboard.js";
import Orders from "./pages/orders/orders.jsx";
import Reports from "./pages/Reports/reports.jsx";
import ProfitLossReport from "./pages/Reports/profitLoss.jsx";
import ProtectedRoute from "./pages/auth/ProtectedRoute.jsx";
import Register from "./pages/auth/register.jsx";
import Login from "./pages/auth/login.jsx";
import AddUserManagement from "./pages/addUsers/addUserManagement.jsx";
import Menuitems from "./pages/foodMenu/menu.jsx";
import LogsData from "./pages/logsData/logs.jsx";
import { socket } from "./utils/socket.js";
import Footer from "./components/layout/Footer.jsx";
// import GlobalSocketListener from "./context/GlobalSocketListener.jsx";

function AppContent() {
  const { showNotification } = useNotification(); // ✅ Now inside provider
  const [isLoading] = useState(false);
  const [error] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const isAdmin = user?.isAdmin === true;

  // Close sidebar on route change
  useEffect(() => {
    // const handleRouteChange = () => {
    //   setSidebarOpen(false);
    // };

    // Listen for navigation changes
    return () => {
      setSidebarOpen(false);
    };
  }, []);

  useEffect(() => {
    socket.on("connect", () => {
      showNotification("🟢 Socket Connected", "info");
    });

    socket.on("disconnect", () => {
      showNotification("🔴 Socket Disconnected", "error");
    });

    return () => {
      socket.off("connect");
      socket.off("disconnect");
    };
  }, [showNotification]);

  const DashboardLayout = () => (
    <div className="dashboard-container">
      <NavbarAside
        userData={user}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      <div className="main-content">
        <Headers
          userData={user}
          onMenuToggle={() => setSidebarOpen(!sidebarOpen)}
        />

        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "80vh",
            }}
          >
            <CircularProgress />
          </Box>
        ) : error ? (
          <div className="error-container">
            <p>Error: {error}</p>
            <button onClick={() => window.location.reload()}>Retry</button>
          </div>
        ) : (
          <Outlet />
        )}
        <Footer />
      </div>
    </div>
  );

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<DashboardLayout />}>
            <Route path="dashboard" element={<Dashboard userData={user} />} />
            <Route path="orders" element={<Orders userData={user} />} />
            {isAdmin && (
              <>
                <Route path="menu" element={<Menuitems />} />
                <Route path="addUsers" element={<AddUserManagement />} />
                <Route path="reports" element={<Reports />} />
                <Route
                  path="reports/profit-loss"
                  element={<ProfitLossReport />}
                />
                <Route path="logs" element={<LogsData />} />
              </>
            )}
          </Route>
        </Route>
        <Route
          path="*"
          element={<Navigate to={user ? "/dashboard" : "/login"} />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <NotificationProvider>
      {/* <GlobalSocketListener /> */}
      <AppContent />
    </NotificationProvider>
  );
}
